import axios from "axios";
import { DataGrid, LoadPanel } from "devextreme-react";
import AuthFileUploader from "../../../common/AuthFileUploader";
import {
  Column,
  ColumnChooser,
  Editing,
  Export,
  FilterRow,
  HeaderFilter,
  Item,
  Paging,
  Position,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
  Summary,
  Toolbar,
  TotalItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import { useEffect, useRef, useState } from "react";
import { saveAs } from "file-saver-es";
import { notifyMsg } from "../../../common/notify";

import "./index.css";
import { useSelector } from "react-redux";
import styled from "styled-components";

const SitePaymentStatusWrapper = styled.div`
  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function SitePaymentStatus(props) {
  const { sales } = props;

  const sitePaymentStatusGridRef = useRef(null);

  const userInfo = useSelector((state) => state.userInfo);

  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: ["contrNo", "siteNo"],
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteContr/clinicalSitePaytStatus/${sales.contrNo}`
          );

          return result.data;
        },
        update: async (key, values) => {
          delete values.totCT;

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteContr/clinicalSitePaytStatus/${key.contrNo}/${key.siteNo}`,
            values
          );
        },
      })
    );
  }, [sales.contrNo]);

  const headerCellRender = () => {
    return (
      <div>
        Site Information <br /> (Site No.-Site Name-PI Name)
      </div>
    );
  };

  const calculateCellValue = (data) =>
    // `${data.siteNo}-${data.LAB_NAME}-${data.INSPCT_MANAGER_NAME}`;
    `${data.siteNo}-${data.yadmNm}-${data.INSPCT_MANAGER_NAME}`;

  const calculateCustomSummary = (options) => {
    if (options.name == "1st") {
      // calculateTotalValue(options, "1st");
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      }
      if (options.summaryProcess == "calculate") {
        if (options.value["1st"]) {
          options.totalValue++;
        }
      }
    } else if (options.name == "2nd") {
      // calculateTotalValue(options, "2nd");
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      }
      if (options.summaryProcess == "calculate") {
        if (options.value["2nd"]) {
          options.totalValue++;
        }
      }
    } else if (options.name == "3rd") {
      // calculateTotalValue(options, "3rd");
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      }
      if (options.summaryProcess == "calculate") {
        if (options.value["3rd"]) {
          options.totalValue++;
        }
      }
    } else if (options.name == "4th") {
      // calculateCellValue(options, "4th");
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      }
      if (options.summaryProcess == "calculate") {
        if (options.value["4th"]) {
          options.totalValue++;
        }
      }
    } else if (options.name == "5th") {
      // calculateCellValue(options, "5th");
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      }
      if (options.summaryProcess == "calculate") {
        if (options.value["5th"]) {
          options.totalValue++;
        }
      }
    } else if (options.name == "6th") {
      // calculateCellValue(options, "6th");
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      }
      if (options.summaryProcess == "calculate") {
        if (options.value["6th"]) {
          options.totalValue++;
        }
      }
    } else if (options.name == "7th") {
      // calculateCellValue(options, "7th");
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      }
      if (options.summaryProcess == "calculate") {
        if (options.value["7th"]) {
          options.totalValue++;
        }
      }
    } else if (options.name == "8th") {
      // calculateTotalValue(options, "initial");
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      }
      if (options.summaryProcess == "calculate") {
        if (options.value["8th"]) {
          options.totalValue++;
        }
      }
    }
  };

  const onEditorPreparing = (e) => {
    const onValueChangedDefaultHandler = e.editorOptions.onValueChanged;

    if (
      e.parentType == "dataRow" &&
      (e.dataField == "initial" || e.dataField.match(/^\d/))
    ) {
      e.editorOptions.onValueChanged = function (args) {
        e.setValue(args.value);

        let totCT = 0;

        for (const property in e.row.data) {
          if (e.row.data[property] && property.match(/^\d/)) {
            totCT += 1;
          }
        }

        if (args.value && !e.row.data[e.dataField]) {
          totCT++;
        }

        sitePaymentStatusGridRef.current.instance.cellValue(
          e.row.rowIndex,
          "totCT",
          totCT
        );
        // }

        onValueChangedDefaultHandler(args);
      };
    }
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#A9D08E";
    }
  };

  const onExporting = (e) => {
    sitePaymentStatusGridRef.current.instance.clearFilter();

    e.component.beginUpdate();
    e.component.columnOption("contrNo", "visible", true);
    e.component.columnOption("siteNo", "visible", true);

    const workbook = new Workbook();

    workbook.creator = "BeTree";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet("Site Payment Status");

    worksheet.properties.defaultRowHeight = 13.5;

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }) => {
        excelCell.font = {
          size: 10,
        };

        excelCell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        if (gridCell.rowType === "data") {
          switch (gridCell.column.dataField) {
            case "contrNo":
            case "siteNo":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FBFBFBF" },
              };
              break;
          }
        } else if (gridCell.rowType === "header") {
          excelCell.font = {
            bold: true,
            size: 10,
          };
          excelCell.alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FA9D08E",
            },
          };

          switch (gridCell.column.dataField) {
            case "contrNo":
              worksheet.getColumn(excelCell.col).width = 15;
              break;
            case "siteNo":
            case "no":
              worksheet.getColumn(excelCell.col).width = 7;
              break;
            case "siteInfo":
              worksheet.getColumn(excelCell.col).width = 50;
              break;
            default:
              worksheet.getColumn(excelCell.col).width = 15;
              break;
          }
        }
        // else if (gridCell.rowType === "totalFooter") {
        //   excelCell.font = {
        //     bold: true,
        //     size: 10,
        //   };
        //   excelCell.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: {
        //       argb: "F007048",
        //     },
        //   };
        //   excelCell.font = {
        //     color: {
        //       argb: "FFFFFFF",
        //     },
        //     bold: true,
        //     size: 10,
        //   };
        // }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/octet-stream",
          }),
          `Site Payment Status_${sales.contrNo}.xlsx`
        );
      });

      e.component.columnOption("contrNo", "visible", false);
      e.component.columnOption("siteNo", "visible", false);
      e.component.endUpdate();

      notifyMsg("Site Payment Status 파일이 다운로드 되었습니다.", "success");
    });
  };

  const onHidingLoadPanel = () => {
    setLoadPanelVisible(false);
  };

  const onUploadStarted = (e) => {
    setLoadPanelVisible(true);
  };

  const onUploaded = (e) => {
    setLoadPanelVisible(false);

    notifyMsg("Site Payment Status 파일이 업로드되었습니다.", "success");

    sitePaymentStatusGridRef.current.instance.refresh();
  };

  const onUploadError = (e) => {
    setLoadPanelVisible(false);

    if (e.error.response) {
      notifyMsg(JSON.parse(e.error.response).error.Message, "error");
    } else {
      notifyMsg("에러가 발생했습니다. 관리자에게 문의해주세요.", "error");
    }
  };

  return (
    <SitePaymentStatusWrapper>
      <DataGrid
        id="sitePaymentStatusGrid"
        ref={sitePaymentStatusGridRef}
        dataSource={dataSource}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        rowAlternationEnabled={true}
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        width={"100%"}
        headerFilter={"100%"}
        repaintChangesOnly={true}
        highlightChanges={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        style={{ maxHeight: "800px" }}
        onEditorPreparing={onEditorPreparing}
        onCellPrepared={onCellPrepared}
        onExporting={onExporting}
      >
        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
        <Scrolling
          mode={"virtual"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtua"}
          showScrollbar={"always"}
        />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <Paging enabled={false} />
        <Sorting mode={"multiple"} />
        <Selection mode={"single"} />
        <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
          <Position
            my={"right top"}
            at={"right bottom"}
            of={".dx-datagrid-column-chooser-button"}
          />
        </ColumnChooser>

        <Editing
          mode={"batch"}
          allowUpdating={true}
          selectTextOnEditStart={true}
          startEditAction={"dblClick"}
        />

        <Export enabled={true} />

        <Toolbar>
          <Item location={"before"}>
            <div className="file-uploader-block">
              <AuthFileUploader
                id="sitePaymentStatusFileUploader"
                width={500}
                uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteContr/clinicalSitePaytStatus?employeeNo=${userInfo.employeeNo}`}
                allowedFileExtensions={[".xlsx"]}
                showFileList={false}
                onUploadStarted={onUploadStarted}
                onUploaded={onUploaded}
                onUploadError={onUploadError}
              />
            </div>
          </Item>
          <Item location={"after"} name={"saveButton"} />
          <Item location={"after"} name={"revertButton"} />
          <Item location={"after"} name={"exportButton"} />
          <Item location={"after"} name={"columnChooserButton"} />
          <Item location={"after"} name={"searchPanel"} />
        </Toolbar>

        <Column
          dataField={"contrNo"}
          caption={"Contract No."}
          dataType={"string"}
          visible={false}
        />
        <Column
          dataField={"siteNo"}
          caption={"Site No."}
          // dataType={"number"}
          dataType={"string"}
          width={60}
          visible={false}
        />
        <Column
          dataField="no"
          caption={"No."}
          dataType={"number"}
          width={60}
          allowEditing={false}
        />
        <Column
          dataField={"siteInfo"}
          caption={"Site Information"}
          dataType={"string"}
          allowEditing={false}
          width={400}
          headerCellRender={headerCellRender}
          calculateCellValue={calculateCellValue}
        />
        <Column caption={"Payment Schedule for Investigator Fee"}>
          <Column
            dataField={"1st"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
          <Column
            dataField={"2nd"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
          <Column
            dataField={"3rd"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
          <Column
            dataField={"4th"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
          <Column
            dataField={"5th"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
          <Column
            dataField={"6th"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
          <Column
            dataField={"7th"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
          <Column
            dataField={"8th"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
        </Column>
        <Column
          dataField={"totCT"}
          caption={"Total Count"}
          dataType={"string"}
          allowEditing={false}
          width={100}
        />
        <Column dataField={"cmt"} caption={"Comment"} dataType={"string"} />

        <Summary
          calculateCustomSummary={calculateCustomSummary}
          recalculateWhileEditing={true}
        >
          <TotalItem
            column={"siteInfo"}
            showInColumn={"siteInfo"}
            displayFormat={"Count"}
          />
          <TotalItem
            name={"1st"}
            showInColumn={"1st"}
            summaryType={"custom"}
            displayFormat={"{0}"}
          />
          <TotalItem
            name={"2nd"}
            showInColumn={"2nd"}
            summaryType={"custom"}
            displayFormat={"{0}"}
          />
          <TotalItem
            name={"3rd"}
            showInColumn={"3rd"}
            summaryType={"custom"}
            displayFormat={"{0}"}
          />
          <TotalItem
            name={"4th"}
            showInColumn={"4th"}
            summaryType={"custom"}
            displayFormat={"{0}"}
          />
          <TotalItem
            name={"5th"}
            showInColumn={"5th"}
            summaryType={"custom"}
            displayFormat={"{0}"}
          />
          <TotalItem
            name={"6th"}
            showInColumn={"6th"}
            summaryType={"custom"}
            displayFormat={"{0}"}
          />
          <TotalItem
            name={"7th"}
            showInColumn={"7th"}
            summaryType={"custom"}
            displayFormat={"{0}"}
          />
          <TotalItem
            name={"8th"}
            showInColumn={"8th"}
            summaryType={"custom"}
            displayFormat={"{0}"}
          />

          <TotalItem
            column={"totCT"}
            summaryType={"sum"}
            displayFormat={"{0}"}
          />
        </Summary>
      </DataGrid>
      <LoadPanel
        shadingColor="rgba(0, 0, 0, 0.4)"
        position={{
          of: "#sitePaymentStatusGrid",
        }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        onHiding={onHidingLoadPanel}
      ></LoadPanel>
    </SitePaymentStatusWrapper>
  );
}
